<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-card title="유해위험기계기구 기본정보" :collapsed="true" class="cardClassDetailInfo">
        <template slot="card-detail">
          <div v-if="editable && equipInfo.plantName" class="col-3">
            <c-label-text title="사업장" :value="equipInfo.plantName"></c-label-text>
          </div>
          <div v-if="editable && equipInfo.machineryClassificationName" class="col-3">
            <c-label-text title="기계분류" :value="equipInfo.machineryClassificationName"></c-label-text>
          </div>
          <div v-if="editable && equipInfo.machineryName" class="col-3">
            <c-label-text title="기계명" :value="equipInfo.machineryName"></c-label-text>
          </div>
          <div v-if="editable && equipInfo.itemNo" class="col-3">
            <c-label-text title="item No" :value="equipInfo.itemNo"></c-label-text>
          </div>
        </template>
      </c-card>
      <c-table
        ref="table"
        title="유해위험기계기구 검사이력"
        tableId="hazardEquipmentHis"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="equipInfo.hazardEquipmentHistoryModels"
        :usePaging="false"
        :checkClickFlag="false"
        :merge="grid.merge"
        selection="multiple"
        rowKey="inspectionNo"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable" label="추가" :showLoading="false"  icon="add" @btnClicked="addItem" />
            <c-btn v-if="editable && equipInfo.hazardEquipmentHistoryModels.length > 0" label="삭제" :showLoading="false" icon="remove" @btnClicked="removeItem" />
            <c-btn
              v-if="editable && equipInfo.hazardEquipmentHistoryModels.length > 0"
              :url="insertUrl"
              :isSubmit="isSave"
              :param="equipInfo.hazardEquipmentHistoryModels"
              mappingType="POST"
              label="저장"
              icon="save"
              @beforeAction="saveHistory"
              @btnCallback="saveCallback" />
          </q-btn-group>
        </template>
       <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'click'">
            <q-chip outline square
              v-if="props.row.editFlag !== 'C'"
              color="blue"
              :clickable="true"
              :editable="editable"
              text-color="white"
              @click="linkClick(props.row, col.name)">
              {{'클릭'}}
            </q-chip>
            <q-chip
              v-else
              outline square
              color="red"
              text-color="white">
              <q-avatar icon="info" color="red" text-color="white" />
              {{'저장하세요'}}
            </q-chip>
          </template>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'hazard-equipment-history',
  props: {
    equipInfo: {
      type: Object,
      default: () => ({
        hhmHazardousMachineryId: '',
        equipmentCd: '',
        plantName: '',
        machineryClassificationName: '',
        itemNo: '',
        machineryName: '',
        emplacementMonth: '',
        inspectionSubjectFlagName: '',
        inspectionCycleName: '',
        gradeName: '',
        resultName: '',
        departmentDeptName: '',
        departmentUserName: '',
        inspectionKindName: '',
        machineryClassification: null,
        hazardEquipmentHistoryModels: []
      }),
    },
  },
  data() {
    return {
      editable: true,
      grid: {
        columns: [
          {
            required: true,
            name: "inspectionDate",
            field: "inspectionDate",
            label: "검사일",
            style: 'width:120px',
            align: "center",
            type: 'date',
            sortable: false,
          },
          {
            name: "departmentDeptName",
            field: "departmentDeptName",
            label: "주관부서",
            style: 'width:120px',
            align: "center",
            type: 'dept',
            deptCd: 'departmentDeptCd',
            sortable: false,
          },
          {
            name: "inspectionAgency",
            field: "inspectionAgency",
            label: "기관(검사원명)",
            style: 'width:120px',
            align: "left",
            type: 'text',
            sortable: false,
          },
          {
            required: true,
            name: "inspectionResultCd",
            field: "inspectionResultCd",
            label: "판정",
            style: 'width:100px',
            type: 'select',
            comboItems: [
              { code: 'HRC000005', codeName: '합격' },
              { code: 'HRC000010', codeName: '불합격' },
            ],
            align: "center",
            sortable: false,
          },
          {
            name: "inspectionResultDetail",
            field: "inspectionResultDetail",
            label: "검사결과 상세",
            style: 'width:350px',
            type: 'textarea',
            align: "left",
            sortable: false,
          },
          {
            name: 'click',
            field: 'click',
            label: '안전검사결과',
            align: 'center',
            type: 'custom',
            style: 'width: 100px',
            sortable: false,
          },
          {
            name: 'attach',
            field: 'attach',
            label: '첨부파일',
            align: 'center',
            style: 'width:200px',
            type: 'attach',
            taskClassCd: 'HAZARD_EQUIPMENT',
            keyText: 'inspectionNo',
            sortable: false,
          },
        ],
        height: '700px',
        data: [],
      },
      isSave: false,
      checkCdItems: [], // 검사결과
      getUrl: '',
      getStdUrl: '',
      insertUrl: '',
      deleteUrl: '',
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    Object.assign(this.$data, this.$options.data());
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.insertUrl = transactionConfig.sop.hhm.hazard.hazardHistory.insert.url;
      this.deleteUrl = transactionConfig.sop.hhm.hazard.hazardHistory.delete.url;
      this.getStdUrl = selectConfig.sop.hhm.hazard.check.get.url;
      this.getUrl = selectConfig.sop.hhm.hazard.hazardHistory.get.url;
    },
    addItem() {
      this.equipInfo.hazardEquipmentHistoryModels.splice(0, 0, {
        hhmHazardousMachineryId: this.equipInfo.hhmHazardousMachineryId,
        inspectionNo: uid(),
        inspectionDate: '',
        departmentDeptCd: '',
        inspectionAgency: '',
        inspectionResultCd: null,
        inspectionResultDetail: '',
        editFlag: 'C',
      })
    },
    removeItem() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.deleteUrl;
          this.$http.type = 'DELETE';
          this.$http.param = {
            data: Object.values(selectData)
          }
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('saveCallback', this.equipInfo.hhmHazardousMachineryId)
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
      }
    },
    saveHistory() {
      let isConti = true;
      let checkItem = ['inspectionDate', 'inspectionResultCd' ]
      this.$_.forEach(this.equipInfo.hazardEquipmentHistoryModels, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [검사일, 검사결과]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.isSave = !this.isSave;
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      } 
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('saveCallback', this.equipInfo.hhmHazardousMachineryId)
    },
    linkClick(result) {
      this.popupOptions.title = this.equipInfo.machineryName + '의 안전검사결과 상세';
      this.popupOptions.target = () => import(`${'./hazardEquipmentHistoryResult.vue'}`);
      this.popupOptions.param = {
        hhmHazardousMachineryId: this.equipInfo.hhmHazardousMachineryId,
        inspectionNo: result ? result.inspectionNo : '', 
        machineryClassification: this.equipInfo.machineryClassification
      } 
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.width = '80%';
      this.popupOptions.closeCallback = this.closeItemPopup;
    },
    closeItemPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.$emit('saveCallback', this.equipInfo.hhmHazardousMachineryId)
    },
  }
};
</script>